export default {
    attachmentsList: {
        remove: 'odstrani',
        addButton: '+ Dodaj prilogo',
        limitReached: 'Dosežena omejitev (20)',
        addTitle: 'Dodaj prilogo',
        urlLabel: 'URL',
    },
}
